import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnNZ: CultureInfo = {
  name: 'en-NZ',
  displayName: 'English (New Zealand)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-NZ',
  parent: CultureInfoEn
};
